module.exports = __webpack_public_path__ + "img/members-right-bsc1.3f654e0e.png";